import { render, staticRenderFns } from "./FormTagsRemoval.vue?vue&type=template&id=fa2651cc"
import script from "./FormTagsRemoval.vue?vue&type=script&lang=js"
export * from "./FormTagsRemoval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports